import classNames from 'classnames';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import css from './Accordion.module.css';

const Accordion = props => {
  const { className, rootClassName, contentClassName, items = [] } = props;

  const classes = classNames(rootClassName || css.root, className);

  const [accordionItems, setAccordionItems] = useState(items);

  const intl = useIntl();

  useEffect(() => {
    if (items) {
      setAccordionItems([
        ...items.map(item => ({
          ...item,
          toggled: item.toggled !== undefined ? item.toggled : false,
        })),
      ]);
    }
  }, [items]);

  const handleAccordionToggle = useCallback(clickedItem => {
    setAccordionItems(prevAccordionItems => [
      ...prevAccordionItems.map(item => ({
        ...item,
        toggled: clickedItem.id === item.id ? !item.toggled : item.toggled,
      })),
    ]);
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <div className={classes}>
      {accordionItems?.map(listItem => {
        return (
          <div
            className={classNames(css.accordion, { [css.toggled]: listItem.toggled })}
            key={`accordion_${listItem.id}`}
          >
            <div className={css.toggle} onClick={() => handleAccordionToggle(listItem)}>
              <p className={css.label}>
                {listItem.renderHeading
                  ? listItem.renderHeading()
                  : intl.formatMessage({ id: listItem.label })}
              </p>
              <div className={css.directionIndicator}>{listItem.toggled ? '-' : '+'}</div>
            </div>
            <div className={css.contentParent}>
              <div className={classNames(css.content, contentClassName)}>
                {listItem.renderContent()}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

Accordion.propTypes = {
  className: string,
  rootClassName: string,
  contentClassName: string,
  items: arrayOf(
    shape({
      id: number,
      toggled: bool,
      label: string,
      renderHeading: func,
      renderContent: func,
    })
  ),
};

export default Accordion;
